import React, {useState, useEffect} from 'react'
import * as THREE from "three"
import { useSelector } from 'react-redux'
import { E_ColoriMetallo } from '../Utils/enumerations'
import { codiciColoreMetallo } from '../Utils/codiciColore'

// Mesh delle basi degli ombrelloni
export default function BasamentoGenerale({nodeCorpoName, mainRotation, pos1, rot1, sc1}) {
    const coloreMetalloOmbrelloni = useSelector(state => state.uiMainMenu.coloreStrutture);  
  
    const [metalColor, setMetalcolor] = useState(codiciColoreMetallo.find(el => el.colore === E_ColoriMetallo.Nero).codice);

    useEffect(() => {  
        if (coloreMetalloOmbrelloni === E_ColoriMetallo.Antracite.toString())  setMetalcolor(codiciColoreMetallo.find(el => el.colore === E_ColoriMetallo.Antracite).codice);
        else if (coloreMetalloOmbrelloni === E_ColoriMetallo.Bianco.toString()) setMetalcolor(codiciColoreMetallo.find(el => el.colore === E_ColoriMetallo.Bianco).codice);
      }, [coloreMetalloOmbrelloni]);
  
    return (
        <group dispose={null} rotation={mainRotation}>
          <group position={pos1} rotation={rot1}>
            <mesh geometry={nodeCorpoName} scale={sc1} >  
              <meshStandardMaterial color={metalColor} roughness={0.25} side={THREE.DoubleSide}/>        
            </mesh>
          </group>     
        </group> 
    )
}
